import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=65abb792&scoped=true&"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./button_group.scss?vue&type=style&index=0&id=65abb792&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65abb792",
  null
  
)

export default component.exports